
attribute float vertexAlpha;
varying float vAlpha;
uniform bool uInvertAlpha;
void main() {
  vAlpha = uInvertAlpha
    ? 1.0 - vertexAlpha
    : vertexAlpha;

  gl_PointSize  = 3.0;
  gl_Position   = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}


